import React from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import styled from 'styled-components'
import { useRouter } from 'next/router'

import useTranslate from 'hooks/useTranslate'
import P from 'components/Typography/P'
import Link from 'components/Link'
import PublicOnlyRoute from 'components/PublicOnlyRoute'
import SignInForm from 'components/Forms/SignInForm'
import { formMaxWidth } from '../components/Fields/common/vars'

import { darkGrey } from '../config/theme/colors'

import { actions as authActions } from 'store/modules/auth'

const ForgotPasswordLink = Link
const ForgotPasswordWrap = styled(P)`
  max-width: ${formMaxWidth}px;
  text-align: right;
`
const Message = styled.div`
  max-width: 500px;
  width: 100%;
  text-align: center;
  background-color: ${darkGrey(0.4)};
  margin-bottom: 30px;
`
const Login = ({redirectPathAfterLogin}) => {
  const dispatch = useDispatch()
  const translate = useTranslate()
  const router = useRouter()
  const { reason, from, email, ...rest } = router.query
  const redirectPath = from || redirectPathAfterLogin
  const message = translate(reason)
  const onSubmit = React.useCallback((values) => {
    const { email, password, keepMeLoggedIn } = values
    return dispatch(authActions.login({ password, email, keepMeLoggedIn }))
      .then(() => {
        if (redirectPath) {
          router.replace({
            pathname: redirectPath,
            query: rest
          })
        } else {
          router.push('/account')
        }
      })
  })

  const initialValues = {
    email
  }

  return (
    <PublicOnlyRoute disableRedirect={!!redirectPath}>
      {!_.isEmpty(message) && (
        <Message>
          <P>
            {message}
          </P>
        </Message>
      )}
      <SignInForm
        initialValues={initialValues}
        onSubmit={onSubmit}
        parseError={authActions.parseError}
      />
      <ForgotPasswordWrap>
        <ForgotPasswordLink href='/forgot-password'>
          {translate('INPUT_FORGOTTEN_PASSWORD')}
        </ForgotPasswordLink>
      </ForgotPasswordWrap>
    </PublicOnlyRoute>
  )
}

export default Login
